import * as yup from 'yup';
import { ObjectSchema } from 'yup';
import { CustomerInformation } from 'types/CustomerInformation';

export const customerInformationSchema: ObjectSchema<CustomerInformation> = yup
  .object({
    FirstName: yup
      .string()
      .required('First name is required')
      .max(50, 'First name cannot exceed 50 characters'),

    LastName: yup
      .string()
      .required('Last name is required')
      .max(50, 'Last name cannot exceed 50 characters'),

    Email: yup
      .string()
      .email('Invalid email address')
      .required('Email is required'),

    MobileNo: yup
      .string()
      .required('Mobile number is required')
      .matches(/^\+?\d{10,15}$/, 'Mobile number must be 10 to 15 digits'),

    Nationality: yup
      .string()
      .required('Nationality is required')
      .max(50, 'Nationality cannot exceed 50 characters'),

    VisaStatus: yup
      .mixed<'Resident' | 'Visitor'>()
      .oneOf(['Resident', 'Visitor'])
      .required('Visa status is required'),

    IsAbove21: yup
      .boolean()
      .required()
      .oneOf([true], 'You must confirm you are above 21 years old'),

    IsTCAccepted: yup
      .boolean()
      .required()
      .oneOf([true], 'You must accept the terms & conditions'),
  })
  .required();
